if (!customElements.get('scrolling-text')) {
  customElements.define(
    'scrolling-text',
    class ScrollingText extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.scrolling-text__track');
        this.speed = parseFloat(this.dataset.speed) || 0.2;
        this.unitWidth = 0;
        this.ticking = false;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.measure();
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      measure() {
        const first = this.track && this.track.firstElementChild;
        this.unitWidth = first ? first.getBoundingClientRect().width : 0;
      }

      onResize() {
        this.measure();
        this.update();
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.update();
          this.ticking = false;
        });
      }

      update() {
        if (!this.track || !this.unitWidth) return;
        const offset = -((window.scrollY * this.speed) % this.unitWidth);
        this.track.style.transform = `translateX(${offset}px)`;
      }
    }
  );
}
